import {
    SUBMIT_MCP_REQUEST,
    SUBMIT_MCP_SUCCESS,
    SUBMIT_MCP_FAILURE,
    SUBMIT_BATCH_MCP_REQUEST,
    SUBMIT_BATCH_MCP_SUCCESS,
    SUBMIT_BATCH_MCP_FAILURE,
} from "actions/mcp";

const initialState = {
    isSubmitting: false,
    isBatchSubmitting: false,
    error: null,
    batchError: null,
    submittedTools: [],
};

const mcpReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBMIT_MCP_REQUEST:
            return {
                ...state,
                isSubmitting: true,
                error: null,
            };
        case SUBMIT_MCP_SUCCESS:
            return {
                ...state,
                isSubmitting: false,
                submittedTools: [...state.submittedTools, action.payload],
            };
        case SUBMIT_MCP_FAILURE:
            return {
                ...state,
                isSubmitting: false,
                error: action.payload,
            };
        case SUBMIT_BATCH_MCP_REQUEST:
            return {
                ...state,
                isBatchSubmitting: true,
                batchError: null,
            };
        case SUBMIT_BATCH_MCP_SUCCESS:
            return {
                ...state,
                isBatchSubmitting: false,
                submittedTools: [...state.submittedTools, ...action.payload],
            };
        case SUBMIT_BATCH_MCP_FAILURE:
            return {
                ...state,
                isBatchSubmitting: false,
                batchError: action.payload,
            };
        default:
            return state;
    }
};

export default mcpReducer;
